import React from "react";
import Hero from "../../components/lourve/mth/hero";
import About from "../../components/lourve/mth/about";
import Designer from "../../components/lourve/mth/designer";
import Video from "../../components/lourve/mth/video";
import Reviews from "../../components/lourve/mth/reviews";
import Contact from "../../components/lourve/mth/contact";
import CardSlide from "../../components/lourve/mth/Slider/card_slide";
// import HeroSection from "../../components/lourve/heroSection";
// import SecondSection from "../../components/lourve/secSection";
// import BestSeller from "../../components/lourve/swiper/bestSeller";
// import DesignerChoice from "../../components/lourve/desinger/designerChoice";
// import VisitToLourve from "../../components/lourve/visit_to_lourve";
// import CustomerReview from "../../components/lourve/customer-review";

const HomePage = () => {
  return (
    // <div className="overflow-hidden">
    //   <HeroSection/>
    //   <SecondSection />
    //   <BestSeller />
    //   <DesignerChoice />
    //   <VisitToLourve />
    //   <CustomerReview />
    // </div>
    <div className="">
      <Hero />
      <About />
      <div className="my-20">
        <CardSlide />
      </div>
      <Designer />
      <Video />
      <Reviews />
      <Contact />
    </div>
  );
};

export default HomePage;
